import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SiteHeader } from './components/layout/site-header/site-header';
import { SiteFooter } from './components/layout/site-footer/site-footer';
import { Breadcrumbs } from './components/layout/breadcrumbs/breadcrumbs';

@Component({
  selector: 'cf-root',
  imports: [RouterOutlet, SiteHeader, SiteFooter, Breadcrumbs],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {}
